import {
  PRODUCT_ID_VALIDATION_MAX_LENGTH,
  productIdValidationValidMiraklIdRegex,
  productIdValidationValidSaeIdRegex,
  productValidationExpExceptionsIdRegex,
} from '../../../product'

const isMatchingAnyException = (id: string): boolean =>
  productValidationExpExceptionsIdRegex.some((regex) => regex.test(id))

/**
 * returns true if query has PZNs
 */
const headerSearchValidateUpidsAndPzns = (id: string): boolean => {
  if (!id || id.length > PRODUCT_ID_VALIDATION_MAX_LENGTH) {
    return false
  }

  let matches = productIdValidationValidSaeIdRegex.exec(id)

  matches ??= productIdValidationValidMiraklIdRegex.exec(id)

  return Boolean(matches) && !isMatchingAnyException(id)
}

export const headerSearchGetPznsAndUpidsFromSearchQuery = (
  searchQuery: string,
): string[] | string => {
  try {
    const possiblePzns = decodeURIComponent(searchQuery)
      .split(/[\s,+]+/gu)
      .filter((value, index, pzns) => pzns.indexOf(value) === index)
      .filter(Boolean)
    const allValid = possiblePzns.every((possiblePzn) =>
      headerSearchValidateUpidsAndPzns(possiblePzn),
    )

    if (!allValid) {
      return searchQuery
    }

    return possiblePzns
  } catch {
    return searchQuery
  }
}
